import { useMemo, useRef } from 'react';
import { useAppSelector } from '../../../redux/hooks';
import { isEqual } from 'lodash';

const useNewVirtualHumanConfig = () => {
  const { interviewInfo } = useAppSelector((state) => state.interview);
  const prevConfigRef = useRef(interviewInfo?.interviewerModeConfig);

  // 使用 useMemo 缓存 interviewerModeConfig，避免每次都返回新的对象引用
  return useMemo(() => {
    const currentConfig = interviewInfo?.interviewerModeConfig;

    // 使用 lodash isEqual 进行深度比较，只有内容真正变化时才更新
    if (!isEqual(prevConfigRef.current, currentConfig)) {
      prevConfigRef.current = currentConfig;
    }

    return (
      prevConfigRef.current || {
        videoURLWide: '',
        ranges: {
          speaking: [],
          listening: [],
        },
      }
    );
  }, [interviewInfo?.interviewerModeConfig]);
};

export default useNewVirtualHumanConfig;
